var map = {
	"./calculator.svg": 294,
	"./excel.svg": 295,
	"./exception_frame.png": 296,
	"./exception_frame.svg": 297,
	"./no_calculator.svg": 298,
	"./no_disconnect.svg": 299,
	"./no_headphones.svg": 300,
	"./no_instant_messaging.svg": 301,
	"./no_internet_browsing.svg": 302,
	"./no_leaving_camera.svg": 303,
	"./no_local_browsing.svg": 304,
	"./no_materials.svg": 305,
	"./no_pause.svg": 306,
	"./no_people_in_room.svg": 307,
	"./no_phone.svg": 308,
	"./no_tv_radio.svg": 309,
	"./notes.svg": 310,
	"./pdf.svg": 311,
	"./people_with_interaction.svg": 312,
	"./people_without_interaction.svg": 313,
	"./powerpoint.svg": 314,
	"./rule_frame.png": 315,
	"./rule_frame.svg": 316,
	"./specific_websites.svg": 317,
	"./textbooks.svg": 318,
	"./word.svg": 319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 293;